/* eslint-disable */
export default {
  searchPlaceholder: 'Recherche…',
  refresh: 'Actualiser',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
